export const action = {
    add: "add",
    apply: "apply",
    cancel: "cancel",
    delete: "delete",
    unknown:"unknown action"
};